import { useEffect, useState } from 'react'
import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default function useMenuVariation(expectHero, autoDetect) {
	const [variation, setVariation] = useState(expectHero ? 'light' : 'dark')

	useEffect(() => {
		if (!expectHero || !autoDetect) {
			return
		}
		const computedRemSize = getComputedStyle(document.querySelector(':root')).fontSize
		const menuHeight =
			typeof computedRemSize === 'string'
				? parseInt(computedRemSize.replace('px', ''), 10) * 5
				: 16 * 5

		const st = ScrollTrigger.create({
			// markers: true,
			trigger: 'main',
			start: `top ${menuHeight}`,
			// end: expectHero ? `bottom ${bottomOffset}px` : `100px ${bottomOffset}px`,

			onLeaveBack: () => {
				setVariation('light')
			},
			onEnter: () => {
				setVariation('dark')
			},
		})

		return () => {
			st.kill()
		}
	}, [expectHero, autoDetect])

	return variation
}
